import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../utils/api';
import { toast } from 'react-toastify';

const EditEmployee = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [departments, setDepartments] = useState([]);
  const [form, setForm] = useState({
    employeeId: '', name: '', email: '', phone: '', department: '',
    designation: '', joiningDate: '', salary: '', status: 'Active'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [empRes, deptRes] = await Promise.all([
          api.get(`/employees/${id}`),
          api.get('/departments')
        ]);
        const emp = empRes.data;
        setForm({
          employeeId: emp.employeeId, name: emp.name, email: emp.email,
          phone: emp.phone, department: emp.department?._id || emp.department,
          designation: emp.designation,
          joiningDate: emp.joiningDate ? emp.joiningDate.split('T')[0] : '',
          salary: emp.salary, status: emp.status
        });
        setDepartments(deptRes.data);
      } catch (err) {
        toast.error('Failed to load employee');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/employees/${id}`, { ...form, salary: Number(form.salary) });
      toast.success('Employee updated');
      navigate('/employees');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Update failed');
    }
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="form-card">
      <h2>Edit Employee</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-grid">
          <div className="form-group"><label>Employee ID</label><input name="employeeId" value={form.employeeId} onChange={handleChange} required /></div>
          <div className="form-group"><label>Name</label><input name="name" value={form.name} onChange={handleChange} required /></div>
          <div className="form-group"><label>Email</label><input type="email" name="email" value={form.email} onChange={handleChange} required /></div>
          <div className="form-group"><label>Phone</label><input name="phone" value={form.phone} onChange={handleChange} required /></div>
          <div className="form-group"><label>Department</label>
            <select name="department" value={form.department} onChange={handleChange} required>
              <option value="">Select Department</option>
              {departments.map(d => <option key={d._id} value={d._id}>{d.name}</option>)}
            </select>
          </div>
          <div className="form-group"><label>Designation</label><input name="designation" value={form.designation} onChange={handleChange} required /></div>
          <div className="form-group"><label>Joining Date</label><input type="date" name="joiningDate" value={form.joiningDate} onChange={handleChange} required /></div>
          <div className="form-group"><label>Salary</label><input type="number" name="salary" value={form.salary} onChange={handleChange} required /></div>
          <div className="form-group"><label>Status</label>
            <select name="status" value={form.status} onChange={handleChange}>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>
        <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
          <button type="submit" className="btn-primary">Update Employee</button>
          <button type="button" className="btn-secondary" onClick={() => navigate('/employees')}>Cancel</button>
        </div>
      </form>
    </div>
  );
};

export default EditEmployee;
